export default {
  init (vue) {
    return {
      getAdvertiserSetting (advId) {
        return vue.$http({
          method: 'GET',
          url: `/api/v1/adchannel/manager/advertiserSetting/${advId}`
        })
      },
      syncADvertiserSetting() {
        return vue.$http({
          method: 'PUT',
          url: `/api/v1/adchannel/manager/advertiserSetting`
        })
      },
      updateADvertiserReservationRule(data) {
        return vue.$http({
          method: 'PUT',
          url: `/api/v1/adchannel/manager/updateADvertiserReservationRule`,
          data: data
        })
      },
      updateADvertiserReservationSkipRule(data) {
        return vue.$http({
          method: 'PUT',
          url: `/api/v1/adchannel/manager/updateADvertiserReservationSkipRule`,
          data: data
        })
      }
    }
  }
}
